import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { Fragment, useContext, useEffect, useState } from "react";
import DebounceInput from "react-debounce-input";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Select from "react-select";
import Switch from "react-switch";
import {
   Alert as ReactstrapAlert, Button, ButtonGroup, Col, Input,
   Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table
} from "reactstrap";
import { ItemDropdownMenu, OrderDropdownMenu, SortHeader } from ".";
import { api, constants, dateHelpers, helpers, UserContext } from "../utils";

export default function WarehouseShippingScheduleCurrentWeekGrid(props) {
   const { currentUser } = useContext(UserContext);
   const [data, setData] = useState();
   const [editAllLineDates, setEditAllLineDates] = useState(false);
   const [editCopy, setEditCopy] = useState(null);
   const [editIndex, setEditIndex] = useState(null);
   const [itemIndex, setItemIndex] = useState(null);
   const [orderTrackingNumbers, setOrderTrackingNumbers] = useState([]);
   const [shippingOptions, setShippingOptions] = useState([]);
   const [showFreightQuoteModal, setShowFreightQuoteModal] = useState(false);
   const [showTrackingNumberModal, setShowTrackingNumberModal] = useState(false);
   const [total, setTotal] = useState(0);
   const [updatedFreightQuote, setUpdatedFreightQuote] = useState("");
   const [updatedTrackingNumber, setUpdatedTrackingNumber] = useState("");
   const [validationMessage, setValidationMessage] = useState(null);
   const [working, setWorking] = useState(false);
   const canEdit = currentUser?.isAPUCS || currentUser?.isWarehouseEdit || currentUser?.isPurchasingEdit;
   let alreadyDisplayedList = [];

   useEffect(() => {
      api
         .fetch("Reference/GetShippingCompanyList")
         .then((response) => {
            setShippingOptions(
               _.chain(response.data.companies)
                  .map((cmp) => {
                     return { label: cmp.ddlDescription, value: cmp.ddlValue };
                  })
                  .sortBy((x) => {
                     return x.label;
                  })
                  .value()
            );
         })
         .catch(api.catchHandler);
   }, []);

   useEffect(() => {
      if (data !== props.data) {
         setData(props.data);
         setTotal(
            props.data.reduce(
               (total, currentItem) => (total = total + currentItem.priceRemaining),
               0
            )
         );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.data]);

   function allowEdit(index) {
      setEditIndex(index);
      setEditCopy(_.assign({}, props.data[index]));
   }

   function cancelEdit() {
      setEditIndex(null);
      setEditCopy(null);
      setEditAllLineDates(false);
   }

   function checkIfPrinted(orderDate) {
      // let minDate = new Date("0001-01-01T00:00:00Z");
      // let date = new Date(orderDate);
      if (orderDate !== "0001-01-01T00:00:00") {
         return true;
      } else {
         return false;
      }
   }

   function getExcel() {
      setWorking(true);
      props.exportXlsxCallback(props.schedule);
      setWorking(false);
   }

   function handleAddFreightQuote(item) {
      if (updatedFreightQuote === "" || updatedFreightQuote === null) {
         setValidationMessage("Quote is required.");
         return;
      }
      const payload = {
         OrderId: _.trim(item.orderId),
         OrderType: item.orderType,
         FreightQuote: updatedFreightQuote,
      };

      api
         .post(`Customer/UpdateOrderFreightQuote`, payload)
         .then((response) => {
            if (response.data.success) {
               props.onUpdateRow();
               if (_.isString(response?.data?.message)) {
                  toast.success(response?.data?.message);
               }
            } else {
               if (_.isString(response?.data?.message)) {
                  toast.error(response?.data?.message);
               }
            }
         })
         .catch(api.catchHandler);
   }

   function handleAddTrackingNumber(item) {
      if (!updatedTrackingNumber) {
         setValidationMessage("Tracking Number is required.");
         return;
      }
      const payload = {
         OrderId: _.trim(item.orderId),
         OrderType: item.orderType,
         NewTrackingNum: updatedTrackingNumber,
      };
      api
         .post(`Customer/UpdateOrderTrackingNumber`, payload)
         .then((response) => {
            if (response.data.success) {
               props.onUpdateRow();
               toast.success(updatedTrackingNumber + " added!");
            } else {
               if (_.isString(response?.data?.message)) {
                  toast.error(response?.data?.message);
               } else {
                  toast.error("Could not add tracking #!");
               }
            }
         })
         .catch(api.catchHandler);
   }

   function handleChange(field, value) {
      const copyUpdate = _.assign({}, editCopy);
      copyUpdate[field] = value;
      setEditCopy(copyUpdate);
   }

   function onAddFreightQuote(index, currentQuote) {
      setShowFreightQuoteModal(true);
      setItemIndex(index);
      setUpdatedFreightQuote(currentQuote);
   }

   function onAddTrackingNumber(index, orderId) {
      setShowTrackingNumberModal(true);
      setItemIndex(index);

      const payload = {
         OrderId: _.trim(orderId),
      };

      api
         .post("Customer/GetShipmentTrackingNumbers", payload)
         .then((response) => {
            setOrderTrackingNumbers(response.data.orderTrackingNumbers);
         })
         .catch(api.catchHandler);
   }

   function updateOrderLine() {
      setWorking(true);
      const payload = _.chain({})
         .assign(editCopy)
         .pickBy((_v, k) => editCopy[k] !== props.data[editIndex][k])
         .value();
      if (payload.unitPrice) {
         payload["currencyDecimals"] = editCopy.currencyDecimals;
      }
      if (payload.releaseQty) {
         payload["qtyRemaining"] = editCopy.qtyRemaining;
      }
      if (payload.requiredShipDate) {
         payload["editAllLineDates"] = editAllLineDates;
      }

      if (_.keys(payload).length) {
         payload["orderId"] = editCopy.orderId;
         payload["itemNumber"] = editCopy.itemNumber;

         api
            .post(`Customer/UpdateOrderLine`, payload)
            .then((response) => {
               if (response.data.success) {
                  props.onUpdateRow();
               } else {
                  if (_.isString(response?.data?.message)) {
                     toast.error(response?.data?.message);
                  }
               }
            })
            .catch(api.catchHandler)
            .finally(() => {
               cancelEdit();
            });
      } else {
         cancelEdit();
      }
      setWorking(false);
   }

   function validateEditCopy() {
      if (editCopy === null) {
         return false;
      }
      if (!editCopy.requiredShipDate) {
         //PLAY.dbo.SOP10200
         return true;
      }
      if (!editCopy.shipMethod) {
         //PLAY.dbo.SOP10200
         return true;
      }
      const fulfilledAmt = editCopy.qtyFullfilled <= 0 ? 1 : editCopy.qtyFullfilled;
      if (editCopy.releaseQty < fulfilledAmt || editCopy.releaseQty > 9999999) {
         //ServiceThread.sales.LineReleaseQty || PLAY.dbo.SOP10200
         return true;
      }
      if (editCopy.unitPrice <= 0) {
         //PLAY.dbo.SOP10200
         return true;
      }
      return false;
   }

   return (
      <>
         <Row className="align-items-center">
            <Col className="transparent-background">
               <ButtonGroup className="float-end">
                  {props.data && props.data.length && props.exportXlsxCallback && (
                     <Button
                        title="Download as .xlsx"
                        className="shredButtonExcel float-end ms-2"
                        onClick={getExcel}
                        disabled={working}
                     >
                        <FontAwesomeIcon icon="file-excel" size="lg" />
                     </Button>
                  )}
               </ButtonGroup>
            </Col>
         </Row>
         <Table size="sm" className="data-table">
            <thead className="table-header">
               <tr>
                  <th style={{ width: "7%" }}>
                     <SortHeader
                        displayName="Order"
                        field="OrderId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "OrderId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th>
                     <SortHeader
                        displayName="Status"
                        field="OrderStatus"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "OrderStatus"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th style={{ width: "12%" }}>
                     <SortHeader
                        displayName="Customer"
                        field="CustomerIdNameShipCity"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "CustomerIdNameShipCity"}
                        callback={props.sortCallback}
                     />
                  </th>
                  {props.schedule === constants.SHIPPING_SCHEDULE_TYPES.MachinePartShipping ? null : (
                     <th style={{ width: "10%" }}>
                        <span>Customer<br />P/N</span>
                     </th>
                  )}

                  {!currentUser?.isAnyCustomerTypeRole ? (
                     <th style={{ width: "14%" }}>
                        Item
                     </th>
                  ) : null}
                  <th style={{ width: "11%" }}>
                     <span>Req Ship<br />Date</span>
                  </th>
                  <th style={{ width: "11%" }}>
                     Ship Method
                  </th>
                  <th style={{ width: "5%" }}>
                     <span>Release<br />Qty</span>
                  </th>
                  <th style={{ width: "5%" }}>
                     <span>Applied<br />Qty</span>
                  </th>
                  <th style={{ width: "5%" }}>
                     <span>Available<br />Qty</span>
                  </th>
                  <th style={{ width: "5%" }}>
                     <span>Remaining<br />Qty</span>
                  </th>
                  <th style={{ width: "7%" }}>
                     Ext Price
                  </th>
                  <th>
                     <SortHeader
                        displayName="Freight Carrier"
                        field="ShipperNamePhone"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "ShipperNamePhone"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th>
                     <SortHeader
                        displayName={<span>Sales<br />Person</span>}
                        field="salespersonId"
                        sortDirection={props.sortDirection}
                        sorted={props.sortField === "salespersonId"}
                        callback={props.sortCallback}
                     />
                  </th>
                  <th></th>
               </tr>
            </thead>
            <tbody>
               {_.map(props.data, (datum, index) => {
                  const alreadyDisplayed = _.includes(
                     alreadyDisplayedList,
                     datum.orderId
                  );
                  const isEditing = editIndex === index;
                  const readOnly = !isEditing;
                  const shipDate = isEditing
                     ? dateHelpers.formatDateForServer(editCopy.requiredShipDate)
                     : dateHelpers.toLongDateString(datum.requiredShipDate);
                  //const shipDateJSFormat = new Date(`${datum.requiredShipDate}`);
                  alreadyDisplayedList.push(datum.orderId);
                  return (
                     <tr key={index} className={`tr-${index % 2 === 0 ? "primary" : "secondary"}`}>
                        {alreadyDisplayed ? (
                           <td className="data-cell"><span className="shredLink fw-bold">{datum.orderId}</span></td>
                        ) : (
                           <OrderDropdownMenu
                              invoiceNumber={null}
                              orderId={datum.orderId}
                              attachmentCount={datum.soAttachmentCount}
                              orderType={1}  //orderType={datum.orderType} BOL Screen expects a 1 for normal orders
                              itemNumber={datum.itemNumber}
                              itemLabel={datum.itemWithDesc}
                              customerId={datum.customerId}
                              customerLabel={`${datum.customerId} | ${datum.customerName} ${datum.stCity}, ${datum.stState}`}
                              includeShipOptions={true}
                              onAddFreightQuote={() => {
                                 onAddFreightQuote(index, datum.freightQuote);
                              }}
                              onAddTrackingNumber={() => {
                                 onAddTrackingNumber(index, datum.orderId);
                              }}
                              isScan={true}
                              scanCallback={props.scanCallback}
                              order={datum}
                              schedule={props.schedule}
                              isPick={true}
                              shipping
                           />
                        )}
                        {datum.status === "HOLD" ? (
                           <td className="data-cell fw-bold text-red" children={datum.status} />
                        ): 
                           <td className="data-cell" children={checkIfPrinted(datum.lastPrintDate) ? "Printed" : ""} />
                        }
                        <td className="data-cell">
                           <Link
                              style={{ textDecoration: "none" }}
                              className="shredLink fw-bold"
                              to={`/customer-dashboard/${datum.customerId}`}
                           >
                              {datum.customerIdNameShipCity}
                           </Link>
                        </td>
                        {props.schedule === constants.SHIPPING_SCHEDULE_TYPES.MachinePartShipping ? null
                           : ( <td className="data-cell" children={datum.customerItemNumber} /> )
                        }
                        <ItemDropdownMenu
                           itemNumber = { datum.itemNumber }
                           itemDescription = { datum.itemWithDesc }
                           attachmentCount = { datum.itemAttachmentCount }
                           customerId = { datum.customerId }
                        />
                        <td className="data-cell">
                        {isEditing ? (
                           <Fragment>
                              <Row>
                              <Col>
                                 <Input
                                    type="date"
                                    onChange={(e) => handleChange("requiredShipDate", e.target.value)}
                                    value={shipDate}
                                    style={{ fontSize: "1em" }}
                                 />
                              </Col>
                              </Row>
                              <Row className="align-items-center">
                              <Col xs={3}>
                                 <Switch
                                    className="mt-3"
                                    height={20}
                                    width={48}
                                    checked={editAllLineDates}
                                    onChange={() => setEditAllLineDates(!editAllLineDates)}
                                 />
                              </Col>
                              <Col xs={9}>
                                 <Label
                                    className="pt-2 ps-2 pb-0 mb-0 "
                                    children="Update date on all line items"
                                 />
                              </Col>
                              </Row>
                           </Fragment>
                        ) : (
                           <span>
                              {shipDate}
                           </span>
                        )}
                        </td>
                        <td className="data-cell">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              className={`${isEditing ? "" : "readonly-input"}`}
                              options={shippingOptions}
                              value={ isEditing
                                 ? _.find(shippingOptions, (opt) => opt.value === editCopy.shipMethod)
                                 : _.find(shippingOptions, (opt) => opt.value === datum.shipMethod)
                              }
                              onChange={(e) => handleChange("shipMethod", e.value)}
                              readOnly={readOnly}
                              placeholder={readOnly ? "" : "Select..."}
                              isSearchable
                              styles={isEditing
                                 ? { control: (provided, _state) => ({ ...provided, width: "150px" }) }
                                 : constants.READONLY_SELECT_STYLE}
                           />
                        </td>
                        < td className = "data-cell" >
                           {readOnly ? (
                           datum.releaseQty.toLocaleString()
                           ) : (
                              <Input
                                 type="number"
                                 bsSize="sm"
                                 className={`px-1`}
                                 value={editCopy.releaseQty}
                                 onChange={(e) => handleChange("releaseQty", parseInt(e.target.value))}
                              />
                           )}
                        </td>
                        <td className="data-cell" children={datum.qtyFulfilled.toLocaleString()} />
                        <td className="data-cell" children={datum.qtyAvailable.toLocaleString()} />
                        <td className="data-cell" children={datum.qtyBackOrdered.toLocaleString()} />
                        <td className="data-cell" children={helpers.formatCurrency(datum.priceRemaining)} />
                        <td className="data-cell" children={datum.shipperNamePhone} />
                        <td className="data-cell" children={datum.salespersonId} />
                        {/* Labeled as Ext Price */}
                        {canEdit && (
                           <td className="data-cell">
                              <ButtonGroup className="width95px">
                                 <Button
                                    className={`icon-button me-1 ${isEditing ? "" : "float-end"}`}
                                    title={isEditing ? "Save changes" : "Edit line"}
                                    color={isEditing ? "success" : "info"}
                                    onClick={ isEditing ? updateOrderLine : () => allowEdit(index) }
                                    disabled={
                                       (editIndex !== null && readOnly) ||
                                       validateEditCopy() ||
                                       working
                                    }
                                 >
                                    <FontAwesomeIcon className="whiteIcon" icon={isEditing ? "check" : "edit"} />
                                 </Button>
                                 <Button
                                    className={`icon-button ${isEditing ? "" : "vis-hidden"}`}
                                    color="secondary"
                                    title="Discard changes"
                                    onClick={cancelEdit}
                                    disabled={editIndex !== null && readOnly}
                                 >
                                    <FontAwesomeIcon className="whiteIcon" icon="times" />
                                 </Button>
                              </ButtonGroup>
                           </td>
                        )}
                     </tr>
                  );
                })}
            </tbody >
            <tfoot className="table-footer">
               <tr>
                  {props.schedule === constants.SHIPPING_SCHEDULE_TYPES.MachinePartShipping
                     ? (<td colSpan={"10"}></td>)
                     : (<td colSpan={"11"}></td>)}
                  <td className={`fw-bold`}>{helpers.formatCurrency(total)}</td>
                  <td></td>
                  <td></td>
                  <td></td>
               </tr>
            </tfoot>
         </Table >

      { showFreightQuoteModal? (
         <Modal id = "freight-quote-modal" isOpen = { showFreightQuoteModal }>
            { validationMessage && ( <ReactstrapAlert color="danger" children={validationMessage} /> )}
            <ModalHeader children = "Add Freight Quote" />
            <ModalBody>
               <div className="text-center">{props.data[itemIndex].orderId}</div>
               <div>
                  Freight Quote:
                  <Input
                     type="number"
                     value={updatedFreightQuote}
                     onChange={(e) => setUpdatedFreightQuote(e.target.value)}
                  />
               </div>
            </ModalBody>
            <ModalFooter>
               <ButtonGroup>
                  <Button
                     children="Add Quote"
                     className="button-success"
                     onClick={() => { handleAddFreightQuote(props.data[itemIndex]); }}
                  />
                  <Button
                     children="Cancel"
                     className="button-danger"
                     onClick={() => {
                        setShowFreightQuoteModal(false);
                        setItemIndex(null);
                        setUpdatedFreightQuote("");
                        setValidationMessage(null);
                     }}
                  />
               </ButtonGroup>
            </ModalFooter>
         </Modal >
      ) : null }

      { showTrackingNumberModal ? (
         <Modal id="freight-quote-modal" isOpen={showTrackingNumberModal} >
            {validationMessage && (
               <ReactstrapAlert color="danger" children={validationMessage} />
            )}
            <ModalHeader children="Add Tracking Number" />
            <ModalBody>
               <Row className="mb-3">
                  <Col className="text-center">{props.data[itemIndex].orderId}</Col>
               </Row>
               <Row>
                  <Col>Existing Tracking Numbers:</Col>
               </Row>
               {_.map(orderTrackingNumbers, (x) => {
                  return (
                     <Row className="ml-5">
                        <Col xs="1"></Col>
                        <Col className="ml-5">
                           <div className="ml-5">{x.trackingNumber}</div>
                        </Col>
                     </Row>
                  );
               })}
               <Row className="mt-3">
                  <Col>
                     Tracking Number:
                     <DebounceInput
                        type="text"
                        onChange={(e) => setUpdatedTrackingNumber(e.target.value)}
                        value={updatedTrackingNumber}
                        debounceTimeout={300}
                     />
                  </Col>
               </Row>
            </ModalBody>
            <ModalFooter>
               <ButtonGroup>
                  <Button
                     children="Add Tracking Number"
                     className="button-success"
                     onClick={() => handleAddTrackingNumber(props.data[itemIndex])}
                  />
                  <Button
                     children="Cancel"
                     className="button-danger"
                     onClick={() => {
                        setShowTrackingNumberModal(false);
                        setItemIndex(null);
                        setUpdatedTrackingNumber("");
                        setOrderTrackingNumbers([]);
                        setValidationMessage(null);
                     }}
                  />
               </ButtonGroup>
            </ModalFooter>
         </Modal>
      ) : null }
    </>
  );
}
